import React from 'react';
import { useTranslations } from '@unisporkal/localization';
import styles from '../Messages.module.scss';

const CalculatePriceMessage = () => {
  const t = useTranslations();

  return (
    <div className={styles.buyCardMessage}>
      <p
        className={styles.priceCalculatorMessage}
        data-testid="calculate-price-message"
      >
        {t('calculate_price_message')}
      </p>
    </div>
  );
};

export default CalculatePriceMessage;
